// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bE4E0c {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: auto;
  min-width: 310px; /* Mantém largura mínima específica do componente */
  font-family: var(--font-family-base);
  /* Sem sombra conforme protótipo Figma - apenas borda simples definida no .card */
}

.M3JVm2 {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  gap: var(--spacing-3); /* 24px - Gap principal do container */
  padding: var(--spacing-3); /* 24px - Padding principal do container */
  background-color: var(--profile-menu-background);
  border: 1px solid var(--profile-menu-border);
  border-radius: var(--radius-s); /* 4px - Border radius padrão */
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15); /* Sombra sutil para profundidade */
}

.NVm7op {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: var(--spacing-1-5); /* 12px - Gap entre nome e CPF */
}

.EIy_zk {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: 37px; /* Gap específico do Figma entre nome e close - mantido específico */
}

.Akr0iL {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-semibold); /* 600 - Peso semibold */
  font-size: var(--font-size-xl); /* 20px - Tamanho XL */
  line-height: 1.424; /* Line height específico do Figma - mantido */
  color: var(--profile-menu-user-name-color);
  margin: 0;
  flex: 1;
  text-align: left;
}

.qkJw0u {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: var(--spacing-2); /* 16px - Tamanho do botão close */
  height: var(--spacing-2); /* 16px - Tamanho do botão close */
  background-color: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  flex-shrink: 0;
  color: var(--profile-menu-close-icon-color);
}

.JcZB1y {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  width: 100%;
  gap: var(--spacing-1-5); /* 12px - Gap consistente */
}

.bJvkKy {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-regular); /* 400 - Peso regular */
  font-size: var(--font-size-sm); /* 12px - Tamanho pequeno */
  line-height: 2; /* Line height específico do Figma - mantido */
  color: var(--profile-menu-user-cpf-color);
  margin: 0;
  text-align: left;
}

.wGuCvJ {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--spacing-1); /*  8px - Gap entre itens da listagem*/
  width: 100%;
}

.k28umf {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: var(--spacing-1); /* 8px - Gap entre ícone e texto */
  background-color: transparent;
  border: none;
  border-radius: var(--radius-s); /* 4px - Border radius padrão */
  cursor: pointer;
  padding: 0px;
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-semibold); /* 600 - Peso semibold */
  font-size: var(--font-size-md); /* 14px - Tamanho médio */
  line-height: 1.424; /* Line height específico do Figma - mantido */
  color: var(--profile-menu-sign-out-color);
  transition: background-color 0.2s ease;
  width: auto;
  height: auto;
}

.HNJYGy {
  width: 14px; /* Tamanho específico do ícone do Figma - mantido */
  height: 14px; /* Tamanho específico do ícone do Figma - mantido */
  color: var(--profile-menu-sign-out-color);
}

.coNtsN {
  min-width: 220px; /* Garante que o container tenha largura para o alinhamento */
  padding-bottom: 6px;
  border-bottom: 1px solid #dcdcdc;
  color: var(--profile-menu-user-cpf-color);
  font-family: var(--font-family-base);
}

.k80Mbo {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.ZalLDW {
  font-size: 12px;
}

.SCgTH9 {
  font-size: 12px;
  text-transform: uppercase;
  color: var(--profile-menu-user-name-color);
  margin: 0;
}

.HmJne_ {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}

/* Alinha o segundo grupo (Conta) à direita para um visual mais limpo */
.nMCUQJ:last-child {
  text-align: right;
  align-items: flex-end;
}

.IM5F50 {
  font-size: 12px;
  padding-right: 5px;
  font-weight: 400;
}

.eqI5S6 {
  font-size: 12px;
  font-weight: 600;
  color: var(--profile-menu-user-name-color);
}
`, "",{"version":3,"sources":["webpack://./../../packages/shared-ui/src/components/ProfileMenu/ProfileMenu.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,gBAAgB,EAAE,mDAAmD;EACrE,oCAAoC;EACpC,iFAAiF;AACnF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,WAAW;EACX,qBAAqB,EAAE,sCAAsC;EAC7D,yBAAyB,EAAE,0CAA0C;EACrE,gDAAgD;EAChD,4CAA4C;EAC5C,8BAA8B,EAAE,+BAA+B;EAC/D,0CAA0C,EAAE,mCAAmC;AACjF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,uBAAuB,EAAE,gCAAgC;AAC3D;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,SAAS,EAAE,oEAAoE;AACjF;;AAEA;EACE,oCAAoC;EACpC,wCAAwC,EAAE,wBAAwB;EAClE,8BAA8B,EAAE,sBAAsB;EACtD,kBAAkB,EAAE,8CAA8C;EAClE,0CAA0C;EAC1C,SAAS;EACT,OAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB,EAAE,kCAAkC;EAC3D,wBAAwB,EAAE,kCAAkC;EAC5D,6BAA6B;EAC7B,YAAY;EACZ,eAAe;EACf,UAAU;EACV,cAAc;EACd,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,WAAW;EACX,uBAAuB,EAAE,2BAA2B;AACtD;;AAEA;EACE,oCAAoC;EACpC,uCAAuC,EAAE,uBAAuB;EAChE,8BAA8B,EAAE,2BAA2B;EAC3D,cAAc,EAAE,8CAA8C;EAC9D,yCAAyC;EACzC,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,qBAAqB,EAAE,sCAAsC;EAC7D,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB,EAAE,kCAAkC;EACzD,6BAA6B;EAC7B,YAAY;EACZ,8BAA8B,EAAE,+BAA+B;EAC/D,eAAe;EACf,YAAY;EACZ,oCAAoC;EACpC,wCAAwC,EAAE,wBAAwB;EAClE,8BAA8B,EAAE,yBAAyB;EACzD,kBAAkB,EAAE,8CAA8C;EAClE,yCAAyC;EACzC,sCAAsC;EACtC,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW,EAAE,mDAAmD;EAChE,YAAY,EAAE,mDAAmD;EACjE,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB,EAAE,6DAA6D;EAC/E,mBAAmB;EACnB,gCAAgC;EAChC,yCAAyC;EACzC,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,0CAA0C;EAC1C,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA,uEAAuE;AACvE;EACE,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0CAA0C;AAC5C","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: auto;\n  min-width: 310px; /* Mantém largura mínima específica do componente */\n  font-family: var(--font-family-base);\n  /* Sem sombra conforme protótipo Figma - apenas borda simples definida no .card */\n}\n\n.card {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  width: 100%;\n  gap: var(--spacing-3); /* 24px - Gap principal do container */\n  padding: var(--spacing-3); /* 24px - Padding principal do container */\n  background-color: var(--profile-menu-background);\n  border: 1px solid var(--profile-menu-border);\n  border-radius: var(--radius-s); /* 4px - Border radius padrão */\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15); /* Sombra sutil para profundidade */\n}\n\n.header {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  gap: var(--spacing-1-5); /* 12px - Gap entre nome e CPF */\n}\n\n.topRow {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  gap: 37px; /* Gap específico do Figma entre nome e close - mantido específico */\n}\n\n.userName {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-semibold); /* 600 - Peso semibold */\n  font-size: var(--font-size-xl); /* 20px - Tamanho XL */\n  line-height: 1.424; /* Line height específico do Figma - mantido */\n  color: var(--profile-menu-user-name-color);\n  margin: 0;\n  flex: 1;\n  text-align: left;\n}\n\n.closeButton {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  width: var(--spacing-2); /* 16px - Tamanho do botão close */\n  height: var(--spacing-2); /* 16px - Tamanho do botão close */\n  background-color: transparent;\n  border: none;\n  cursor: pointer;\n  padding: 0;\n  flex-shrink: 0;\n  color: var(--profile-menu-close-icon-color);\n}\n\n.userInfo {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  width: 100%;\n  gap: var(--spacing-1-5); /* 12px - Gap consistente */\n}\n\n.userCpf {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-regular); /* 400 - Peso regular */\n  font-size: var(--font-size-sm); /* 12px - Tamanho pequeno */\n  line-height: 2; /* Line height específico do Figma - mantido */\n  color: var(--profile-menu-user-cpf-color);\n  margin: 0;\n  text-align: left;\n}\n\n.itemListing {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: var(--spacing-1); /*  8px - Gap entre itens da listagem*/\n  width: 100%;\n}\n\n.signOutButton {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  gap: var(--spacing-1); /* 8px - Gap entre ícone e texto */\n  background-color: transparent;\n  border: none;\n  border-radius: var(--radius-s); /* 4px - Border radius padrão */\n  cursor: pointer;\n  padding: 0px;\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-semibold); /* 600 - Peso semibold */\n  font-size: var(--font-size-md); /* 14px - Tamanho médio */\n  line-height: 1.424; /* Line height específico do Figma - mantido */\n  color: var(--profile-menu-sign-out-color);\n  transition: background-color 0.2s ease;\n  width: auto;\n  height: auto;\n}\n\n.signOutIcon {\n  width: 14px; /* Tamanho específico do ícone do Figma - mantido */\n  height: 14px; /* Tamanho específico do ícone do Figma - mantido */\n  color: var(--profile-menu-sign-out-color);\n}\n\n.headerAccountInfoContainer {\n  min-width: 220px; /* Garante que o container tenha largura para o alinhamento */\n  padding-bottom: 6px;\n  border-bottom: 1px solid #dcdcdc;\n  color: var(--profile-menu-user-cpf-color);\n  font-family: var(--font-family-base);\n}\n\n.headerAccountInstitutionBox {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.headerAccountIpLabel {\n  font-size: 12px;\n}\n\n.headerAccountCompanyName {\n  font-size: 12px;\n  text-transform: uppercase;\n  color: var(--profile-menu-user-name-color);\n  margin: 0;\n}\n\n.headerAccountDataRow {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-end;\n}\n\n/* Alinha o segundo grupo (Conta) à direita para um visual mais limpo */\n.headerAccountFieldGroup:last-child {\n  text-align: right;\n  align-items: flex-end;\n}\n\n.headerAccountFieldLabel {\n  font-size: 12px;\n  padding-right: 5px;\n  font-weight: 400;\n}\n\n.headerAccountFieldValue {\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--profile-menu-user-name-color);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `bE4E0c`,
	"card": `M3JVm2`,
	"header": `NVm7op`,
	"topRow": `EIy_zk`,
	"userName": `Akr0iL`,
	"closeButton": `qkJw0u`,
	"userInfo": `JcZB1y`,
	"userCpf": `bJvkKy`,
	"itemListing": `wGuCvJ`,
	"signOutButton": `k28umf`,
	"signOutIcon": `HNJYGy`,
	"headerAccountInfoContainer": `coNtsN`,
	"headerAccountInstitutionBox": `k80Mbo`,
	"headerAccountIpLabel": `ZalLDW`,
	"headerAccountCompanyName": `SCgTH9`,
	"headerAccountDataRow": `HmJne_`,
	"headerAccountFieldGroup": `nMCUQJ`,
	"headerAccountFieldLabel": `IM5F50`,
	"headerAccountFieldValue": `eqI5S6`
};
module.exports = ___CSS_LOADER_EXPORT___;
